import React, { memo } from "react";
import { Card, CardContent } from "components/ui";
import SettingCardSkeleton, {
  FooterButtonSkeleton,
} from "./SettingCardSkeleton";

const CompanyInfoSkeleton = memo(() => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 lg:gap-7.5 mb-[20px]">
      <div className="xl:col-span-2">
        <Card className="min-w-full">
          <CardContent>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 lg:gap-7.5">
              <SettingCardSkeleton
                titleWidth={130}
                controls={["input", "input"]}
              />
              <SettingCardSkeleton
                titleWidth={130}
                controls={["input", "input", "input"]}
              />
            </div>
          </CardContent>

          <FooterButtonSkeleton />
        </Card>
      </div>
    </div>
  );
});

CompanyInfoSkeleton.displayName = "CompanyInfoSkeleton";

export default CompanyInfoSkeleton;
